document.addEventListener("DOMContentLoaded", () => {
  const menus = document.querySelectorAll(".details-first-menu");

  menus.forEach((details) => {
    const summary = details.querySelector(":scope > summary");
    if (!summary) return;

    const menuItem = details.closest(".first-level-menu-item");
    const hoverTarget = menuItem || details;

    // role="button" from global.js breaks native <summary> Enter/Space disclosure.
    // Keep native summary semantics for first-level mega menus.
    if (summary.getAttribute("role") === "button") {
      summary.removeAttribute("role");
    }

    const setExpanded = (isOpen) => {
      summary.setAttribute("aria-expanded", isOpen ? "true" : "false");
    };

    const isFocusInsideMenu = () => {
      const activeElement = document.activeElement;
      if (!activeElement) return false;
      if (details.contains(activeElement)) return true;
      return menuItem ? menuItem.contains(activeElement) : false;
    };

    // Mouse hover open/close — bind to full first-level row, not caret-only details
    hoverTarget.addEventListener("mouseenter", () => {
      details.open = true;
      setExpanded(true);
    });
    hoverTarget.addEventListener("mouseleave", () => {
      if (isFocusInsideMenu()) return;
      details.open = false;
      setExpanded(false);
    });

    // Keyboard: Enter/Space toggles disclosure on caret summary
    summary.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();
      details.open = !details.open;
      setExpanded(details.open);
    });
  });

  // 二级导航
  $(".secondary-level-item").hover(
    function () {
      $(".secondary-level-item").removeClass("active");
      $(this).addClass("active");
      $(".three-level-menu-content").removeClass("active");
      var index = $(this).attr("data-index");
      $(`.three-level-menu-content[data-index='${index}']`).addClass("active");
    }
  );
});
